module.exports = __webpack_public_path__ + "img/4.fa066ea6.svg";